import React from 'react';
import LogoGridSection from './LogoGridSection';

const LogoGridSectionWithProps = (props: any) => {
  return (
    <LogoGridSection
      title={props.title}
      description={props.description}
      gridItems={props.gridItems}
      ctaLink={props.ctaLink}
      ctaLabel={props.ctaText}
      theme={props.theme}
    />
  );
};

export default LogoGridSectionWithProps;
